export enum AlertSeverity {
    success = "success",
    error = "error",
    warning = "warning",
    info = "info"
}